'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Switch } from '@achra/ui/switch';
import { RsGroupCostType } from '@/modules/__generated__/graphql/switchboard-generated';
import { getPriceLabel } from '@/modules/service-purchase/lib/utils';
import { usePricingCalculatorContext } from '@/modules/service-purchase/providers/pricing-calculator-provider';
import { useHoveredTier } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import { CatalogStatus } from '@/modules/service-purchase/types';
import { ServiceCatalogStatus } from '../../service-catalog-status';
interface SectionHeaderProps {
  title: string;
  badge?: CatalogStatus;
  hasToggle?: boolean;
  toggleLabel?: string;
  toggleEnabled?: boolean;
  onToggleChange?: (enabled: boolean) => void;
  activePlan?: string;
  groupPrice?: number | null;
  groupDiscountedPrice?: number | null;
  groupCurrency?: string | null;
  groupCostType?: RsGroupCostType | null;
  perTierPrices?: Record<string, string | null> | null;
  isAddOn?: boolean;
  groupSetupPrice?: number | null;
}
function SectionHeader(t0) {
  const $ = _c(105);
  const {
    title,
    badge,
    hasToggle,
    toggleLabel,
    toggleEnabled: t1,
    onToggleChange,
    activePlan,
    groupPrice,
    groupDiscountedPrice,
    groupCurrency,
    groupCostType,
    perTierPrices,
    isAddOn,
    groupSetupPrice
  } = t0;
  const toggleEnabled = t1 === undefined ? false : t1;
  const {
    tierNames
  } = usePricingCalculatorContext();
  const hoveredPlan = useHoveredTier();
  const isOneTime = groupCostType === RsGroupCostType.Setup;
  const isRecurring = groupCostType === RsGroupCostType.Recurring;
  let t2;
  if ($[0] !== groupCurrency || $[1] !== groupSetupPrice || $[2] !== isAddOn) {
    t2 = isAddOn && groupSetupPrice ? getPriceLabel(RsGroupCostType.Setup, groupSetupPrice, groupCurrency) : null;
    $[0] = groupCurrency;
    $[1] = groupSetupPrice;
    $[2] = isAddOn;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const setupPriceLabel = t2;
  let t3;
  if ($[4] !== groupCostType || $[5] !== groupCurrency || $[6] !== groupPrice || $[7] !== isAddOn) {
    t3 = getPriceLabel(groupCostType, groupPrice, groupCurrency, isAddOn);
    $[4] = groupCostType;
    $[5] = groupCurrency;
    $[6] = groupPrice;
    $[7] = isAddOn;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const priceLabel = t3;
  let t4;
  if ($[9] !== groupCostType || $[10] !== groupCurrency || $[11] !== groupDiscountedPrice || $[12] !== isAddOn) {
    t4 = getPriceLabel(groupCostType, groupDiscountedPrice, groupCurrency, isAddOn);
    $[9] = groupCostType;
    $[10] = groupCurrency;
    $[11] = groupDiscountedPrice;
    $[12] = isAddOn;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const discountedPriceLabel = t4;
  const t5 = hasToggle && "group/addon cursor-pointer transition-colors";
  let t6;
  if ($[14] !== t5) {
    t6 = cn("text-foreground items-center", "grid grid-cols-2 lg:grid-cols-(--grid-cols-lg) xl:grid-cols-(--grid-cols-xl)", t5);
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== hasToggle || $[17] !== onToggleChange || $[18] !== toggleEnabled) {
    t7 = hasToggle ? () => onToggleChange?.(!toggleEnabled) : undefined;
    $[16] = hasToggle;
    $[17] = onToggleChange;
    $[18] = toggleEnabled;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = `4fr repeat(${tierNames.length}, minmax(144px, 1fr))`;
  const t9 = `4fr repeat(${tierNames.length}, minmax(220px, 1fr))`;
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = {
      "--grid-cols-lg": t8,
      "--grid-cols-xl": t9
    };
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = t10 as React.CSSProperties;
  const t12 = hasToggle && "group-hover/addon:bg-accent/60 transition-colors";
  let t13;
  if ($[23] !== t12) {
    t13 = cn("border-input bg-accent flex min-h-14 flex-col justify-center gap-1.5 border-b px-4 lg:px-6", "sticky left-0 z-10 lg:static", t12);
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== badge || $[26] !== hasToggle || $[27] !== onToggleChange || $[28] !== title || $[29] !== toggleEnabled || $[30] !== toggleLabel) {
    t14 = <div className="flex items-center gap-2">{hasToggle ? <div className="flex flex-col gap-1 lg:flex-row lg:items-center lg:gap-2"><div className="flex items-center gap-2"><Switch checked={toggleEnabled} onCheckedChange={onToggleChange} onClick={_temp} id={`toggle-${title}`} className="data-[state=checked]:bg-status-progress data-[state=unchecked]:bg-foreground/70" /><label htmlFor={`toggle-${title}`} className="text-foreground cursor-pointer text-base font-bold" onClick={_temp2}>{toggleLabel ?? title}</label></div>{badge === CatalogStatus.Optional && <ServiceCatalogStatus catalogStatus={badge} />}</div> : <div className="text-foreground flex items-center gap-2 text-base font-bold"><span>{title}</span>{badge === CatalogStatus.Optional && <ServiceCatalogStatus catalogStatus={badge} />}</div>}</div>;
    $[25] = badge;
    $[26] = hasToggle;
    $[27] = onToggleChange;
    $[28] = title;
    $[29] = toggleEnabled;
    $[30] = toggleLabel;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <div className={t13}>{t14}</div>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const t16 = activePlan ? "bg-primary/30" : "bg-accent";
  const t17 = hasToggle && (activePlan ? "group-hover/addon:bg-primary/20" : "group-hover/addon:bg-accent/60");
  let t18;
  if ($[35] !== t16 || $[36] !== t17) {
    t18 = cn("border-input pointer-events-none relative flex h-full min-h-14 min-w-0 items-center justify-center border-b px-4 transition-colors lg:hidden", t16, t17);
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== activePlan || $[39] !== isAddOn || $[40] !== isOneTime || $[41] !== perTierPrices) {
    t19 = !isAddOn && isOneTime && perTierPrices && activePlan && perTierPrices[activePlan] && <span className="text-primary dark:text-primary-foreground min-w-0 text-xs font-bold whitespace-nowrap">{perTierPrices[activePlan]}</span>;
    $[38] = activePlan;
    $[39] = isAddOn;
    $[40] = isOneTime;
    $[41] = perTierPrices;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== activePlan || $[44] !== isAddOn || $[45] !== isRecurring || $[46] !== perTierPrices) {
    t20 = !isAddOn && isRecurring && perTierPrices && activePlan && perTierPrices[activePlan] && <span className="text-primary dark:text-primary-foreground min-w-0 text-xs font-bold whitespace-nowrap uppercase">{perTierPrices[activePlan]}</span>;
    $[43] = activePlan;
    $[44] = isAddOn;
    $[45] = isRecurring;
    $[46] = perTierPrices;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== discountedPriceLabel || $[49] !== isOneTime || $[50] !== perTierPrices || $[51] !== priceLabel) {
    t21 = isOneTime && !perTierPrices && priceLabel && !discountedPriceLabel && <span className="text-primary dark:text-primary-foreground min-w-0 text-xs font-bold whitespace-nowrap uppercase">{priceLabel}</span>;
    $[48] = discountedPriceLabel;
    $[49] = isOneTime;
    $[50] = perTierPrices;
    $[51] = priceLabel;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== discountedPriceLabel || $[54] !== isOneTime || $[55] !== perTierPrices || $[56] !== priceLabel) {
    t22 = isOneTime && !perTierPrices && priceLabel && discountedPriceLabel && <span className="flex min-w-0 flex-col items-center gap-0.5"><span className="text-foreground/60 min-w-0 text-xs whitespace-nowrap uppercase line-through">{priceLabel}</span><span className="text-primary dark:text-primary-foreground min-w-0 text-xs font-bold whitespace-nowrap uppercase">{discountedPriceLabel}</span></span>;
    $[53] = discountedPriceLabel;
    $[54] = isOneTime;
    $[55] = perTierPrices;
    $[56] = priceLabel;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== discountedPriceLabel || $[59] !== isAddOn || $[60] !== priceLabel || $[61] !== setupPriceLabel) {
    t23 = isAddOn && priceLabel && !discountedPriceLabel && <span className="flex items-center gap-2">{setupPriceLabel && <><span className="text-primary dark:text-primary-foreground min-w-0 text-xs font-bold whitespace-nowrap">{setupPriceLabel}</span><span className="text-foreground/40 text-xs">|</span></>}<span className="text-primary dark:text-primary-foreground min-w-0 text-xs font-bold whitespace-nowrap">{priceLabel}</span></span>;
    $[58] = discountedPriceLabel;
    $[59] = isAddOn;
    $[60] = priceLabel;
    $[61] = setupPriceLabel;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== discountedPriceLabel || $[64] !== isAddOn || $[65] !== priceLabel) {
    t24 = isAddOn && priceLabel && discountedPriceLabel && <span className="flex min-w-0 flex-col items-center gap-0.5"><span className="text-foreground/60 min-w-0 text-xs whitespace-nowrap line-through">{priceLabel}</span><span className="text-primary dark:text-primary-foreground min-w-0 text-xs font-bold whitespace-nowrap">{discountedPriceLabel}</span></span>;
    $[63] = discountedPriceLabel;
    $[64] = isAddOn;
    $[65] = priceLabel;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  let t25;
  if ($[67] !== t18 || $[68] !== t19 || $[69] !== t20 || $[70] !== t21 || $[71] !== t22 || $[72] !== t23 || $[73] !== t24) {
    t25 = <div className={t18}>{t19}{t20}{t21}{t22}{t23}{t24}</div>;
    $[67] = t18;
    $[68] = t19;
    $[69] = t20;
    $[70] = t21;
    $[71] = t22;
    $[72] = t23;
    $[73] = t24;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  let t26;
  if ($[75] !== activePlan || $[76] !== discountedPriceLabel || $[77] !== hasToggle || $[78] !== hoveredPlan || $[79] !== isAddOn || $[80] !== isOneTime || $[81] !== isRecurring || $[82] !== perTierPrices || $[83] !== priceLabel || $[84] !== setupPriceLabel || $[85] !== tierNames) {
    let t27;
    if ($[87] !== activePlan || $[88] !== discountedPriceLabel || $[89] !== hasToggle || $[90] !== hoveredPlan || $[91] !== isAddOn || $[92] !== isOneTime || $[93] !== isRecurring || $[94] !== perTierPrices || $[95] !== priceLabel || $[96] !== setupPriceLabel) {
      t27 = plan => <div key={plan} className={cn("border-input pointer-events-none relative hidden h-full min-h-14 min-w-0 items-center justify-center border-b px-6 transition-colors lg:flex", activePlan === plan ? "bg-primary/30" : "bg-accent", hoveredPlan === plan && activePlan !== plan && "bg-accent/70", hasToggle && (activePlan === plan ? "group-hover/addon:bg-primary/20" : "group-hover/addon:bg-accent/60"))}>{!isAddOn && isOneTime && perTierPrices?.[plan] && <span className={cn("min-w-0 text-xs font-bold whitespace-nowrap uppercase", activePlan === plan ? "text-primary dark:text-primary-foreground" : "text-foreground/70")}>{perTierPrices[plan]}</span>}{!isAddOn && isRecurring && perTierPrices?.[plan] && <span className={cn("min-w-0 text-xs font-bold whitespace-nowrap uppercase", activePlan === plan ? "text-primary dark:text-primary-foreground" : "text-foreground/70")}>{perTierPrices[plan]}</span>}{isOneTime && !perTierPrices && plan === activePlan && priceLabel && !discountedPriceLabel && <span className="text-primary dark:text-primary-foreground min-w-0 text-center text-xs font-bold uppercase">{priceLabel}</span>}{isOneTime && !perTierPrices && plan === activePlan && priceLabel && discountedPriceLabel && <span className="flex min-w-0 flex-col items-center gap-0.5"><span className="text-foreground/60 min-w-0 text-center text-xs line-through">{priceLabel}</span><span className="text-primary dark:text-primary-foreground min-w-0 text-center text-xs font-bold uppercase">{discountedPriceLabel}</span></span>}{isAddOn && plan === activePlan && priceLabel && !discountedPriceLabel && <span className="flex min-w-0 flex-col items-center gap-0.5">{setupPriceLabel && <span className="text-primary dark:text-primary-foreground min-w-0 text-center text-xs font-bold">{setupPriceLabel}</span>}<span className="text-primary dark:text-primary-foreground min-w-0 text-center text-xs font-bold">{priceLabel}</span></span>}{isAddOn && plan === activePlan && priceLabel && discountedPriceLabel && <span className="flex min-w-0 flex-col items-center gap-0.5"><span className="text-foreground/60 min-w-0 text-center text-xs line-through">{priceLabel}</span><span className="text-primary dark:text-primary-foreground min-w-0 text-center text-xs font-bold">{discountedPriceLabel}</span></span>}</div>;
      $[87] = activePlan;
      $[88] = discountedPriceLabel;
      $[89] = hasToggle;
      $[90] = hoveredPlan;
      $[91] = isAddOn;
      $[92] = isOneTime;
      $[93] = isRecurring;
      $[94] = perTierPrices;
      $[95] = priceLabel;
      $[96] = setupPriceLabel;
      $[97] = t27;
    } else {
      t27 = $[97];
    }
    t26 = tierNames.map(t27);
    $[75] = activePlan;
    $[76] = discountedPriceLabel;
    $[77] = hasToggle;
    $[78] = hoveredPlan;
    $[79] = isAddOn;
    $[80] = isOneTime;
    $[81] = isRecurring;
    $[82] = perTierPrices;
    $[83] = priceLabel;
    $[84] = setupPriceLabel;
    $[85] = tierNames;
    $[86] = t26;
  } else {
    t26 = $[86];
  }
  let t27;
  if ($[98] !== t11 || $[99] !== t15 || $[100] !== t25 || $[101] !== t26 || $[102] !== t6 || $[103] !== t7) {
    t27 = <div className={t6} onClick={t7} style={t11}>{t15}{t25}{t26}</div>;
    $[98] = t11;
    $[99] = t15;
    $[100] = t25;
    $[101] = t26;
    $[102] = t6;
    $[103] = t7;
    $[104] = t27;
  } else {
    t27 = $[104];
  }
  return t27;
}
function _temp2(e_0) {
  e_0.stopPropagation();
}
function _temp(e) {
  e.stopPropagation();
}
export { SectionHeader };